module.exports = __webpack_public_path__ + "javascripts/components/RepublishPanel/cc.logo-daf1fc0e8847c0bbcb9b786c82e9d981.svg";